module.exports = __webpack_public_path__ + "static/media/question.de318cc9.svg";